var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass:
            "body align-self-center d-flex flex-column justify-content-center align-items-center"
        },
        [
          _c("div", { staticClass: "logo-container" }, [
            _c("div", {
              staticClass: "signin-logo mb-4",
              domProps: { innerHTML: _vm._s(_vm.svg.logo) }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            {
              staticClass:
                "p-4 mb-0 input-card d-flex flex-column align-items-stretch",
              attrs: { "no-body": "" }
            },
            [
              _c("b-card-body", [
                _c(
                  "div",
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("AUTH.USER_LOGIN")))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("AUTH.EMAIL")))]),
                    _vm._v(" "),
                    _c(
                      "b-input-group",
                      { staticClass: "mb-3" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _c("i", { staticClass: "fa fa-user" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.email,
                              expression: "user.email"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.$v.user.email.$error,
                            "is-valid": !_vm.$v.user.email.$invalid
                          },
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("AUTH.EMAIL")
                          },
                          domProps: { value: _vm.user.email },
                          on: {
                            blur: function($event) {
                              _vm.$v.user.email.$touch()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.user, "email", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.$v.user.email.required
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.$t("AUTH.EMPTY_EMAIL")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.user.email.email
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.$t("AUTH.INVALID_EMAIL")))
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("AUTH.PASSWORD")))]),
                    _vm._v(" "),
                    _c(
                      "b-input-group",
                      { staticClass: "mb-4" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _c("i", { staticClass: "fa fa-lock" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.password,
                              expression: "user.password"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.$v.user.password.$error,
                            "is-valid": !_vm.$v.user.password.$invalid
                          },
                          attrs: {
                            type: "password",
                            placeholder: _vm.$t("AUTH.PASSWORD")
                          },
                          domProps: { value: _vm.user.password },
                          on: {
                            blur: function($event) {
                              _vm.$v.user.password.$touch()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.user,
                                "password",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        !_vm.$v.user.password.required
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.$t("AUTH.EMPTY_PASSWORD")))
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-center", attrs: { cols: "12" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "login-btn",
                                attrs: {
                                  variant: "secondary",
                                  disabled:
                                    _vm.$v.$invalid || _vm.isLoginLoading
                                },
                                on: { click: _vm.loginSubmit }
                              },
                              [_vm._v(_vm._s(_vm.$t("AUTH.LOGIN")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-center mb-2 seperator",
                  attrs: { cols: "12" }
                },
                [_c("h5", [_vm._v("OR")])]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("span", { staticClass: "ms-label" }, [
                        _vm._v("Login with")
                      ]),
                      _vm._v(" "),
                      _c("b-img", {
                        attrs: {
                          src: "../../../static/img/microsoft.png",
                          fluid: "",
                          alt: "Fluid image"
                        },
                        on: { click: _vm.msLogin }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10634756", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10634756","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ManualLogin.vue
// module id = 1059
// module chunks = 2